import React from 'react';
import FadeIn from '../components/ui/FadeIn';
import SafeIcon from '../common/SafeIcon';
import Button from '../components/ui/Button';

const ServiceCard = ({ number, title, desc, features, icon, isDark }) => (
  <div className={`rounded-[3rem] p-10 md:p-14 transition-all duration-500 group relative overflow-hidden border ${isDark ? 'bg-brand-dark text-white border-brand-dark' : 'bg-white text-brand-dark border-black/5 hover:modern-shadow'}`}>
    <div className={`absolute -right-10 -top-10 text-[200px] font-serif font-bold opacity-5 group-hover:scale-110 group-hover:rotate-12 transition-transform duration-1000 z-0 select-none pointer-events-none ${isDark ? 'text-white' : 'text-brand-dark'}`}>
      {number}
    </div>
    
    <div className="relative z-10 flex flex-col h-full">
      <div className={`w-20 h-20 rounded-3xl flex items-center justify-center mb-10 ${isDark ? 'bg-white/10 text-brand-accent backdrop-blur-md border border-white/10' : 'bg-brand-cream text-brand-accent'}`}>
        <SafeIcon name={icon} className="w-10 h-10" />
      </div>
      
      <h3 className="text-4xl font-serif mb-6">{title}</h3>
      <p className={`mb-12 leading-relaxed text-lg font-light ${isDark ? 'text-white/70' : 'text-brand-text'}`}>{desc}</p>
      
      <div className="mt-auto">
        <h4 className={`font-bold uppercase tracking-[0.15em] text-xs mb-6 ${isDark ? 'text-brand-accent' : 'text-brand-dark'}`}>Kerninhalte</h4>
        <ul className="grid sm:grid-cols-2 gap-y-4 gap-x-8 mb-12">
          {features.map((feature, idx) => (
            <li key={idx} className="flex items-start gap-4">
              <span className={`w-1.5 h-1.5 rounded-full mt-2 shrink-0 ${isDark ? 'bg-brand-accent' : 'bg-brand-dark'}`}></span>
              <span className={`text-base font-light ${isDark ? 'text-white/90' : 'text-brand-text'}`}>{feature}</span>
            </li>
          ))}
        </ul>
        
        <Button to="/kontakt" variant={isDark ? "darkGlass" : "outline"} className="w-full sm:w-auto">
          Dazu beraten lassen
        </Button>
      </div>
    </div>
  </div>
);

const Services = () => {
  return (
    <div className="pt-32 pb-32 bg-brand-cream min-h-screen">
      <div className="container mx-auto px-6 max-w-7xl">
        <FadeIn className="max-w-4xl mb-24">
          <span className="text-brand-accent font-bold tracking-[0.2em] uppercase text-sm mb-6 block">Expertise</span>
          <h1 className="text-5xl md:text-7xl font-serif mb-8 text-brand-dark leading-tight">Transformation für <br/><span className="italic text-brand-accent">deine Marke.</span></h1>
          <p className="text-xl text-brand-text font-light max-w-2xl">
            Ganzheitliche Beratung, die High-End Design, strategischen Vertrieb und starkes Mindset vereint. Für Beauty-Unternehmerinnen, die bereit für das nächste Level sind.
          </p>
        </FadeIn>

        <div className="grid lg:grid-cols-2 gap-8">
          <FadeIn delay={0.1}>
            <ServiceCard 
              number="01"
              icon="Instagram"
              title="Instagram Premium"
              desc="Wir machen dein Profil zum Magneten für kaufkräftige Wunschkunden. Kein Zufall mehr, sondern strategisches Branding und Conversion-optimierter Content."
              features={[
                "Profil- & Bio-Optimierung",
                "Editorial Feed-Design",
                "Verkaufsstarke Story-Strategie",
                "Reels mit Reichweite"
              ]}
              isDark={true}
            />
          </FadeIn>

          <FadeIn delay={0.2}>
            <ServiceCard 
              number="02"
              icon="TrendingUp"
              title="Umsatz & Struktur"
              desc="Dein Talent verdient faire Bezahlung. Wir optimieren deine Angebote, schnüren unwiderstehliche Pakete und etablieren souveräne Verkaufswege."
              features={[
                "Premium Preisstrukturen",
                "High-Ticket Paketangebote",
                "Upselling-Psychologie",
                "Umsatz-Skalierung"
              ]}
              isDark={false}
            />
          </FadeIn>

          <FadeIn delay={0.3}>
            <ServiceCard 
              number="03"
              icon="Monitor"
              title="Digitale Systeme"
              desc="Raus aus dem Hustle, rein in die Struktur. Wir implementieren Tools, die dir täglich Arbeit abnehmen und Kunden automatisierter binden."
              features={[
                "Smarte Online-Buchung",
                "Digitale Kundenverwaltung",
                "Automatisierte Reminder",
                "Review-Management"
              ]}
              isDark={false}
            />
          </FadeIn>

          <FadeIn delay={0.4}>
            <ServiceCard 
              number="04"
              icon="Star"
              title="Mindset & Auftritt"
              desc="Werde zur unangefochtenen Autorität in deiner Nische. Ich coache dich, Unsicherheiten abzulegen und als souveräne Personal Brand aufzutreten."
              features={[
                "Kamera-Präsenz stärken",
                "Souveräne Kommunikation",
                "Personal Brand Aufbau",
                "Glaubenssätze shiften"
              ]}
              isDark={true}
            />
          </FadeIn>
        </div>
      </div>
    </div>
  );
};

export default Services;